export const langBoardList = {
  fr: {
    add: 'Ajouter',
    modify: 'Modifier',
    delete: 'Supprimer',
    search: 'Rechercher',
    save: 'Enregistrer',
    cancel: 'Annuler',
    board_brand_head: 'Marque',
    board_model_head: 'Modèle',
    board_year_head: 'Année',
    board_volume_head: 'Volume (l)',
    board_active_head: 'Active',
    twoMin: '3 caractères minimum',
    threeMin: '3 caractères minimum',
    noBoards: `Cliquez sur le bouton Ajouter pour saisir votre première board.`,
    registeredOnly: 'Réservé aux utilisateurs enregistrés',
  },
  eng: {
    add: 'Add',
    modify: 'Modify',
    delete: 'Delete',
    board_brand_head: 'Brand',
    search: 'Search',
    save: 'Save',
    cancel: 'Cancel',
    board_model_head: 'Model',
    board_year_head: 'Year',
    board_volume_head: 'Volume (l)',
    board_active_head: 'Active',
    twoMin: '3 characters minimum',
    threeMin: '3 characters minimum',
    noBoards: `Click the Add button to enter your first board.`,
    registeredOnly: 'Registered users only',
  },
}
